<template>
  <section id="login-user">
    <div class="title">
      <div>
        <h1>Identification</h1>
        <p>Cher visiteur cinéphile, vous devez à présent être identifié pour accéder au contenu du site.</p>
        <p>Connectez-vous ou inscrivez-vous simplement avec votre prénom et votre jour de naissance 😉.</p>
        <p>Clément</p>
        <div>
          <h2>Connexion / Inscription</h2>
            <div class="erreur" v-if="error">{{error}}</div>
            <form @submit.prevent="handleAuth">
              <el-input placeholder="Prénom" v-model="formAuth.name"></el-input>
              <el-select v-model="formAuth.dayOfBirth" placeholder="Jour de naissance">
                <el-option label="Jour de naissance" value=""></el-option>
                <el-option v-for="day in 31" :label="day" :value="day" :key="day"></el-option>
              </el-select>
              <el-button type="primary" native-type="submit">Se connecter / S'inscrire</el-button>
            </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {
      formAuth: {
        name: "",
        dayOfBirth: ""
      },
      error: null
    };
  },
  methods: {
    handleAuth() {
      const trimmedName = this.formAuth.name.trim().replace(/\s/g, '');
      const email = `${trimmedName}${this.formAuth.dayOfBirth}@cinema-francais-d-autrefois.com`;
      const password = email; // Utiliser le même format pour le mot de passe

      if (!trimmedName) {
        this.error = "ERREUR : Prénom manquant.";
        return;
      }

      if (!this.formAuth.dayOfBirth) {
        this.error = "ERREUR : Jour de naissance manquant.";
        return;
      }

      firebase.auth().signInWithEmailAndPassword(email, password)
        .then(() => {
          window.location.reload();
        })
        .catch((signInError) => {
          if (signInError.code === 'auth/user-not-found') {
            // Tenter de créer un nouveau compte si l'utilisateur n'existe pas
            firebase.auth().createUserWithEmailAndPassword(email, password)
              .then(() => {
                window.location.reload();
              })
              .catch((createError) => {
                this.error = createError.message;
              });
          } else {
            this.error = signInError.message;
          }
        });
    }
  },
  name: "LoginUser"
};
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

#login-user {
  padding: 1em 0 1em 0;
    
  .title {
    padding: 1.5em;
    position: relative;
    text-align: center;
    z-index: 2;
    background: url("../assets/img/box-border-patern.png") repeat 0 0
      $--color-hcf-beige;

    &:before {
      background: $--color-hcf-light-beige;
      bottom: 0;
      content: "";
      display: block;
      left: 0;
      margin: 1.5em;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
    }
    > div {
        width: 90%;
        margin: auto;
        margin-bottom: 1.7rem;
        max-width: 25rem;

        p {
          line-height: 1.2;
          font-size: 0.9rem;
        }

        .erreur
        {
          color: #a51f1e;
          font-size: 0.8rem;
          margin: 0.5rem 0;
          margin-bottom: 0.2rem;
        }

        > div 
        {
          max-width: 20rem;
          margin: auto;
          margin-top: 2.9rem;
          padding: 1.7rem 0;
          padding-bottom: 0;
          border-top: 1px dotted #baa88c;

          &:last-child {
            margin-bottom: 3.1rem;
          }
        }

        h1, h2 {
            font-family: "Righteous";
            color: $--color-hcf-ddark-brown;
            font-size: 1.6em;
            text-shadow: 3px 3px 0 rgba(0, 0, 0, 0.12);
            line-height: 1.2;
            margin: 0.8em 1em .5em 1em;
            letter-spacing: 0.05rem;
        }

        h2 {
          font-size: 1.4em;
          color: $--color-hcf-red;
          text-shadow: 3px 3px 0 rgba(216, 188, 188, 0.2)
        }

        .el-input, .el-button, .el-select {
            margin: 0.5em 0;
            width: 100%;
        }
    }
  }
}
</style>